// Bygger et kategoritre fra den flate listen GET /kategorier returnerer (hver
// kategori peker på sin forelder via overordnetKategori). Dybde-først, sortert
// alfabetisk innenfor hvert nivå. Delt mellom Kategorier.jsx (administrasjon)
// og Varelager.jsx (import-overstyring) - unngår at de to driver fra
// hverandre slik de hardkodede SYKKEL_UNDERGRUPPER-listene tidligere gjorde.
export function byggKategoriTre(kategorier) {
  const barnAvForelder = new Map();
  for (const k of kategorier) {
    const forelderNøkkel = k.overordnetKategori ? String(k.overordnetKategori) : "";
    if (!barnAvForelder.has(forelderNøkkel)) barnAvForelder.set(forelderNøkkel, []);
    barnAvForelder.get(forelderNøkkel).push(k);
  }
  for (const liste of barnAvForelder.values()) {
    liste.sort((a, b) => a.navn.localeCompare(b.navn, "no"));
  }

  const resultat = [];
  function leggTil(forelderNøkkel, dybde) {
    for (const k of barnAvForelder.get(forelderNøkkel) || []) {
      resultat.push({ ...k, dybde });
      leggTil(String(k._id), dybde + 1);
    }
  }
  leggTil("", 0);
  return resultat;
}
